<div class="pd" *ngIf="showForm">
    <form nz-form [formGroup]="profileForm" (ngSubmit)="submitForm()">
        <nz-form-item *ngIf="renderInstitution">
            <nz-col nzSpan="24">
                <!-- <nz-form-label nzFor="name" nzRequired
                >Institution</nz-form-label
            > -->
                <nz-form-control nzErrorTip="{{'PROFILE.USER-PROFILE.REQUIRED_ERROR_TIP' | translate}}">
                    <input nz-input name="name" type="text" id="name" class="v2-input mt-2" formControlName="name" />
                </nz-form-control>
            </nz-col>
        </nz-form-item>

        <nz-form-item>
            <nz-col nzSpan="24">
                <!-- <nz-form-label nzFor="email" nzRequired
                >E-mail</nz-form-label
            > -->
                <nz-form-control nzErrorTip="{{'PROFILE.USER-PROFILE.REQUIRED_ERROR_TIP' | translate}}">
                    <input nz-input name="email" type="email" id="email" class="v2-input mt-2" formControlName="email"
                        readonly />
                </nz-form-control>
            </nz-col>
        </nz-form-item>

        <nz-form-item *ngIf="renderNames">
            <nz-col nzSpan="24">
                <!-- <nz-form-label nzFor="surname" nzRequired
                >Surname</nz-form-label
            > -->
                <nz-form-control nzErrorTip="{{'PROFILE.USER-PROFILE.REQUIRED_ERROR_TIP' | translate}}">
                    <input nz-input name="surname" type="text" id="surname" class="v2-input mt-2"
                        formControlName="surname" [readOnly]="disableField" />
                </nz-form-control>
            </nz-col>
        </nz-form-item>

        <div nz-row [nzGutter]="{ xs: 8, sm: 16, md: 24, lg: 36 }">
            <div nz-col class="gutter-row" nzXs="24" nzSm="24" nzMd="12" nzLg="12" nzXl="12">
                <nz-form-item *ngIf="renderNames">
                    <nz-col nzSpan="24">
                        <!-- <nz-form-label nzFor="firstname" nzRequired
                    >First Name</nz-form-label
                > -->
                        <nz-form-control nzErrorTip="{{'PROFILE.USER-PROFILE.REQUIRED_ERROR_TIP' | translate}}">
                            <input nz-input name="firstname" type="text" class="v2-input mt-2" id="firstname"
                                formControlName="firstname" [readOnly]="disableField" />
                        </nz-form-control>
                    </nz-col>
                </nz-form-item>
            </div>

            <div nz-col class="gutter-row" nzXs="24" nzSm="24" nzMd="12" nzLg="12" nzXl="12">
                <nz-form-item *ngIf="renderNames">
                    <nz-col nzSpan="24">
                        <!-- <nz-form-label nzFor="middlename"
                    >Middle Name</nz-form-label
                > -->
                        <nz-form-control>
                            <input nz-input name="middlename" type="text" class="v2-input mt-2" id="middlename"
                                formControlName="middlename" [readOnly]="disableField" />
                        </nz-form-control>
                    </nz-col>
                </nz-form-item>
            </div>
        </div>

        <nz-form-item>
            <nz-col [nzSpan]="24">
                <!-- <nz-form-label nzFor="phoneNumber">Phone Number</nz-form-label> -->
                <nz-form-control>
                    <input nz-input name="phone" type="phone" class="v2-input mt-2" id="phoneNumber"
                        formControlName="phone" readonly />
                </nz-form-control>
            </nz-col>
        </nz-form-item>



        <nz-form-item nz-row class="register-area">
            <nz-form-control [nzSm]="12" [nzXs]="12" [nzMd]="8" [nzLg]="8" [nzXl]="10" [nzXXl]="6">
                <button class="v2-btn-primary" nz-button [nzType]="'primary'" [nzLoading]="loading"
                    [disabled]="!profileForm.valid" nzBlock>
                    {{'GENERAL.SUBMIT' | translate | uppercase}}
                </button>
            </nz-form-control>
              <nz-form-control [nzSm]="12" [nzXs]="12" [nzMd]="8" [nzLg]="8" [nzXl]="10" [nzXXl]="6">
                    <button nz-button class="btn-clear" (click)="hideEditForm()" [nzLoading]="loading"
                        nzBlock>
                        {{'GENERAL.CANCEL' | translate | uppercase}}
                    </button>
                </nz-form-control>
        </nz-form-item>
    </form>
</div>

@if(!showForm) {
@if(renderInstitution) {
<div class="verifier-info-panel mt-2">
    <div>
        <div>
            <p class="label">{{'PROFILE.USER-PROFILE.INSTITUTION' | translate}}</p>
            @if(!isLoading) {
            <p class="value">{{userDetails?.name || '-'}}</p>
            } @else {
            <nz-skeleton [nzTitle]="false" [nzParagraph]="{rows: 1}" [nzActive]="true"></nz-skeleton>
            }
        </div>

        <div>
            <p class="label">{{'GENERAL.EMAIL' | translate | uppercase}}</p>
            @if(!isLoading) {
            <p class="value">{{userDetails?.email || '-'}}</p>
            } @else {
            <nz-skeleton [nzTitle]="false" [nzParagraph]="{rows: 1}" [nzActive]="true"></nz-skeleton>
            }
        </div>

        <div>
            <p class="label">{{'GENERAL.PHONE_NUMBER' | translate | uppercase}}</p>
            @if(!isLoading) {
            <p class="value">{{userDetails?.phone || '-'}}</p>
            } @else {
            <nz-skeleton [nzTitle]="false" [nzParagraph]="{rows: 1}" [nzActive]="true"></nz-skeleton>
            }
        </div>
    </div>
    <div>
        @if(!isLoading && !userDetails?.additional_detail?.identity_verified) {
        <button (click)="displayForm()" class="btn-clear">
            <img [src]="urls.EDIT" alt="">
            <span>{{'GENERAL.EDIT_INFO' | translate}}</span>
        </button>
        }
    </div>
</div>
} @else {
    
<div [ngClass]="!userDetails?.additional_detail?.identity_verified && threeColumns ? 'allow-edit' : ''" class="v2-info-panel mt-2">

    <div>
        <p class="label">{{'GENERAL.EMAIL' | translate | uppercase}}</p>
        @if(!isLoading) {
        <p class="value">{{userDetails?.email}}</p>
        } @else {
        <nz-skeleton [nzTitle]="false" [nzParagraph]="{rows: 1}" [nzActive]="true"></nz-skeleton>
        }
    </div>

    @if(userDetails && !userDetails?.additional_detail?.identity_verified && screenWidth > 992) {
        <div class="edit-profile"> 
            <button (click)="displayForm()" class="btn-clear">
                <img [src]="urls.EDIT" alt="">
                <span>{{'GENERAL.EDIT_INFO' | translate}}</span>
            </button>
        </div>
    }

    <div>
        <p class="label">{{'GENERAL.SURNAME' | translate | uppercase}}</p>
        @if(!isLoading) {
        <p class="value">{{userDetails?.surname}}</p>
        } @else {
        <nz-skeleton [nzTitle]="false" [nzParagraph]="{rows: 1}" [nzActive]="true"></nz-skeleton>
        }
    </div>

    <div>
        <p class="label">{{'GENERAL.FIRST_NAME' | translate | uppercase}}</p>
        @if(!isLoading) {
        <p class="value">{{userDetails?.firstname}}</p>
        } @else {
        <nz-skeleton [nzTitle]="false" [nzParagraph]="{rows: 1}" [nzActive]="true"></nz-skeleton>
        }
    </div>

    <div>
        <p class="label">{{'GENERAL.PHONE_NUMBER' | translate | uppercase}}</p>
        @if(!isLoading) {
        <p class="value">{{userDetails?.phone}}</p>
        } @else {
        <nz-skeleton [nzTitle]="false" [nzParagraph]="{rows: 1}" [nzActive]="true"></nz-skeleton>
        }
    </div>

    <div>
        <p class="label">{{'GENERAL.MIDDLE_NAME' | translate | uppercase}}</p>
        @if(!isLoading) {
        <p class="value">{{userDetails?.middlename}}</p>
        } @else {
        <nz-skeleton [nzTitle]="false" [nzParagraph]="{rows: 1}" [nzActive]="true"></nz-skeleton>
        }
    </div>

     @if(userDetails && !userDetails?.additional_detail?.identity_verified && screenWidth < 993) {
        <div> 
            <button (click)="displayForm()" class="btn-clear">
                <img [src]="urls.EDIT" alt="">
                <span>{{'GENERAL.EDIT_INFO' | translate}}</span>
            </button>
        </div>
    }
</div>
}
}
